/* eslint-disable @typescript-eslint/no-unused-vars */
import { Tooltip } from '@chakra-ui/react';
import { Accordion } from '@descomplica/foundation-ui-components';
import { observer, useViewModel } from '@descomplica/microfrontend-react';
import format from 'date-fns/format';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Loading from '../../components/loading';
import { essayStatusEnum } from '../essay/components/essay-item/EssayItem';
import { FeedbackEssayViewModel } from './FeedbackEssay.vm';
import LinkHighlight from './link-highlight';
import {
  BodyEssayContainer,
  BoxEssayCompetenceInfo,
  BoxEssayCompetenceInfoItem,
  BoxEssayCompetenceItem,
  BoxEssayInfo,
  BoxEssayInfoItem,
  Breadcrumb,
  CompetenceBoxTitle,
  CompetenceInfoBody,
  CompetenceInfoScore,
  CompetenceTitle,
  Container,
  EssayBodyTag,
  EssayInfoContainer,
  EssayInstructions,
  EssayInstructionsContainer,
  EssayInstructionsContainerSection,
  InputContainer,
  ItemAccordion,
  OverallComment,
  Score,
  ScoreLabel,
  SidebarContainer,
  StatusInfo,
  StatusTag,
  StatusTitleContainer,
  Title,
  TitleCompetenceComment,
  TitleContainer,
} from './styles';

export const WriteEssay: React.FC = () => {
  const vm = useViewModel(FeedbackEssayViewModel);
  const navigate = useNavigate();
  const { guid } = useParams();

  const openEssay = () => {
    navigate('/essays');
  };

  useEffect(() => {
    if (vm.hasError) {
      navigate('/library');
    }
  }, [vm.hasError, navigate]);

  useEffect(() => {
    const controller = new AbortController();
    const fetchEssayData = async (guid) => await vm.getEssay(guid);

    if (guid) {
      fetchEssayData(guid);
    }

    return () => controller.abort();
  }, [guid, vm.getEssay]);

  if (vm.isLoading || !vm.essay) {
    return <Loading />;
  }

  const handleFeedbackText = (content, feedback) => {
    const text = content;
    let start = 0;
    const elements = [];
    feedback.map((word) => {
      const offset = word.offset;
      const length = word.offset + word.length;

      elements.push(text.substring(start, offset));
      elements.push(
        <LinkHighlight isSelected bgColor="#4AFFB1" color="#333">
          <Tooltip
            label={word.message}
            hasArrow
            color="#191A1A"
            bg="#F2F2F3"
            padding={3}
            arrowSize={15}
            closeDelay={300}
            openDelay={100}
          >
            {text.substring(offset, length)}
          </Tooltip>
        </LinkHighlight>,
      );

      start = length;
    });

    elements.push(text.substring(start, text.length));

    return elements.map((item, i) => {
      return <React.Fragment key={i}>{item}</React.Fragment>;
    });
  };

  const convertStrToEnum = (convertingStr: string): essayStatusEnum => {
    switch (convertingStr) {
      case 'DRAFT':
        return essayStatusEnum.DRAFT;
      case 'SENT':
        return essayStatusEnum.SENT;
      case 'DONE':
        return essayStatusEnum.DONE;
    }
  };

  const enumEssayStatus = convertStrToEnum(vm.essay.status);
  const handleDate = (date: Date) => format(date, 'dd/MM/yyyy');
  const essayText = vm?.essay?.content;

  return (
    <Container>
      <TitleContainer>
        <Breadcrumb onClick={() => openEssay()}>Redação / Minhas redações</Breadcrumb>
        <Title>{vm?.essay?.title}</Title>
      </TitleContainer>
      <BodyEssayContainer>
        <InputContainer>
          <Breadcrumb onClick={() => openEssay()}> {`< Voltar`}</Breadcrumb>

          <EssayBodyTag>Corpo da redação</EssayBodyTag>

          <EssayInfoContainer>
            <p>
              {vm.essay?.enemFeedback?.grammarFeedback
                ? handleFeedbackText(vm?.essay?.content, vm.essay?.enemFeedback?.grammarFeedback)
                : vm?.essay?.content}
            </p>
          </EssayInfoContainer>

          {enumEssayStatus === essayStatusEnum.DONE && (
            <EssayInfoContainer>
              <OverallComment>
                <h2>Comentário geral da redação</h2>
                <p>{vm.essay?.enemFeedback?.overallComment}</p>
              </OverallComment>
            </EssayInfoContainer>
          )}

          {enumEssayStatus === essayStatusEnum.DONE && (
            <EssayInfoContainer>
              <CompetenceBoxTitle>Comentários por competência</CompetenceBoxTitle>

              <Accordion>
                {/* competence 1*/}
                <ItemAccordion>
                  <Accordion.Title>
                    <TitleCompetenceComment>Competência 1</TitleCompetenceComment>
                  </Accordion.Title>
                  <Accordion.Content>
                    <BoxEssayCompetenceInfo>
                      <BoxEssayCompetenceInfoItem>
                        <span>
                          <CompetenceTitle>COMENTÁRIO</CompetenceTitle>
                          <CompetenceInfoBody>
                            {vm.essay.enemFeedback.competence1Comment}
                          </CompetenceInfoBody>
                        </span>
                        <span>
                          <CompetenceTitle>NOTA</CompetenceTitle>
                          <CompetenceInfoScore>
                            {vm.essay.enemFeedback.competence1Score}
                          </CompetenceInfoScore>
                        </span>
                      </BoxEssayCompetenceInfoItem>
                    </BoxEssayCompetenceInfo>
                  </Accordion.Content>
                </ItemAccordion>

                {/* competence 2*/}
                <ItemAccordion>
                  <Accordion.Title>
                    <TitleCompetenceComment>Competência 2</TitleCompetenceComment>
                  </Accordion.Title>
                  <Accordion.Content>
                    <BoxEssayCompetenceInfo>
                      <BoxEssayCompetenceInfoItem>
                        <span>
                          <CompetenceTitle>COMENTÁRIO</CompetenceTitle>
                          <CompetenceInfoBody>
                            {vm.essay.enemFeedback.competence2Comment}
                          </CompetenceInfoBody>
                        </span>
                        <span>
                          <CompetenceTitle>NOTA</CompetenceTitle>
                          <CompetenceInfoScore>
                            {vm.essay.enemFeedback.competence2Score}
                          </CompetenceInfoScore>
                        </span>
                      </BoxEssayCompetenceInfoItem>
                    </BoxEssayCompetenceInfo>
                  </Accordion.Content>
                </ItemAccordion>

                {/* competence 3*/}
                <ItemAccordion>
                  <Accordion.Title>
                    <TitleCompetenceComment>Competência 3</TitleCompetenceComment>
                  </Accordion.Title>
                  <Accordion.Content>
                    <BoxEssayCompetenceInfo>
                      <BoxEssayCompetenceInfoItem>
                        <span>
                          <CompetenceTitle>COMENTÁRIO</CompetenceTitle>
                          <CompetenceInfoBody>
                            {vm.essay.enemFeedback.competence3Comment}
                          </CompetenceInfoBody>
                        </span>
                        <span>
                          <CompetenceTitle>NOTA</CompetenceTitle>
                          <CompetenceInfoScore>
                            {vm.essay.enemFeedback.competence3Score}
                          </CompetenceInfoScore>
                        </span>
                      </BoxEssayCompetenceInfoItem>
                    </BoxEssayCompetenceInfo>
                  </Accordion.Content>
                </ItemAccordion>

                {/* competence 4*/}
                <ItemAccordion>
                  <Accordion.Title>
                    <TitleCompetenceComment>Competência 4</TitleCompetenceComment>
                  </Accordion.Title>
                  <Accordion.Content>
                    <BoxEssayCompetenceInfo>
                      <BoxEssayCompetenceInfoItem>
                        <span>
                          <CompetenceTitle>COMENTÁRIO</CompetenceTitle>
                          <CompetenceInfoBody>
                            {vm.essay.enemFeedback.competence4Comment}
                          </CompetenceInfoBody>
                        </span>
                        <span>
                          <CompetenceTitle>NOTA</CompetenceTitle>
                          <CompetenceInfoScore>
                            {vm.essay.enemFeedback.competence4Score}
                          </CompetenceInfoScore>
                        </span>
                      </BoxEssayCompetenceInfoItem>
                    </BoxEssayCompetenceInfo>
                  </Accordion.Content>
                </ItemAccordion>
                {/* competence 5*/}
                <ItemAccordion>
                  <Accordion.Title>
                    <TitleCompetenceComment>Competência 5</TitleCompetenceComment>
                  </Accordion.Title>
                  <Accordion.Content>
                    <BoxEssayCompetenceInfo>
                      <BoxEssayCompetenceInfoItem>
                        <span>
                          <CompetenceTitle>COMENTÁRIO</CompetenceTitle>
                          <CompetenceInfoBody>
                            {vm.essay.enemFeedback.competence5Comment}
                          </CompetenceInfoBody>
                        </span>
                        <span>
                          <CompetenceTitle>NOTA</CompetenceTitle>
                          <CompetenceInfoScore>
                            {vm.essay.enemFeedback.competence5Score}
                          </CompetenceInfoScore>
                        </span>
                      </BoxEssayCompetenceInfoItem>
                    </BoxEssayCompetenceInfo>
                  </Accordion.Content>
                </ItemAccordion>
              </Accordion>
            </EssayInfoContainer>
          )}
        </InputContainer>

        <SidebarContainer>
          <EssayInstructionsContainer>
            <StatusTitleContainer>
              <StatusTag>Status</StatusTag>
              <StatusInfo>
                {vm.essay.enemFeedback.overallScore ? (
                  <div>
                    <ScoreLabel>Sua nota</ScoreLabel>
                    <Score>
                      {vm.essay.enemFeedback.overallScore}
                      <span>/1000</span>
                    </Score>
                  </div>
                ) : (
                  enumEssayStatus
                )}
              </StatusInfo>
            </StatusTitleContainer>
            <EssayInstructionsContainerSection>
              <Accordion>
                {enumEssayStatus === essayStatusEnum.DONE ? (
                  <Accordion.Item>
                    <Accordion.Title>
                      <EssayInstructions>Resumo da correção</EssayInstructions>
                    </Accordion.Title>
                    <Accordion.Content>
                      <BoxEssayInfo>
                        <BoxEssayCompetenceItem>
                          <span>Competência 1</span>
                          <span>{vm.essay.enemFeedback.competence1Score}</span>
                        </BoxEssayCompetenceItem>
                        <BoxEssayCompetenceItem>
                          <span>Competência 2</span>
                          <span>{vm.essay.enemFeedback.competence2Score}</span>
                        </BoxEssayCompetenceItem>
                        <BoxEssayCompetenceItem>
                          <span>Competência 3</span>
                          <span>{vm.essay.enemFeedback.competence3Score}</span>
                        </BoxEssayCompetenceItem>
                        <BoxEssayCompetenceItem>
                          <span>Competência 4</span>
                          <span>{vm.essay.enemFeedback.competence4Score}</span>
                        </BoxEssayCompetenceItem>
                        <BoxEssayCompetenceItem>
                          <span>Competência 5</span>
                          <span>{vm.essay.enemFeedback.competence5Score}</span>
                        </BoxEssayCompetenceItem>
                      </BoxEssayInfo>
                    </Accordion.Content>
                  </Accordion.Item>
                ) : (
                  <></>
                )}

                <Accordion.Item>
                  <Accordion.Title>
                    <EssayInstructions>Dados da redação</EssayInstructions>
                  </Accordion.Title>
                  <Accordion.Content>
                    <BoxEssayInfo>
                      <BoxEssayInfoItem>
                        <span>Tipo de correção</span> <span>enem</span>
                      </BoxEssayInfoItem>
                      <BoxEssayInfoItem>
                        <span>Data de envio</span>{' '}
                        <span>{`${handleDate(new Date(vm.essay.createdAt))}`}</span>
                      </BoxEssayInfoItem>
                      <BoxEssayInfoItem>
                        <span>Tema</span>
                        <span>{vm.essay.topic.name}</span>
                      </BoxEssayInfoItem>
                    </BoxEssayInfo>
                  </Accordion.Content>
                </Accordion.Item>
              </Accordion>
            </EssayInstructionsContainerSection>
          </EssayInstructionsContainer>
        </SidebarContainer>
      </BodyEssayContainer>
    </Container>
  );
};

export default observer(WriteEssay);
